import { analyticsUtils } from 'utils/analytics-utils';
import { getPathname } from 'utils/get-pathname';
import { getGaSubmitLaminateProjectElementVariant } from 'pages/project-configuration/forms/laminate/helpers/get-ga-submit-laminate-project-element-variant';
import { LaminateInputs } from '../pages/project-configuration/types';

/**
 * Событие срабатывает, когда нажимаешь на кнопку 'Подобрать" при подборе ламината
 */

export const gaSubmitLaminateProject = ({ params }: { params: LaminateInputs }) => {
  const path = getPathname();
  const elementVariant = getGaSubmitLaminateProjectElementVariant(params);

  return analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: `${path}:lvl3`, // блок, в котором расположен элемент
    elementName: 'Проекты PLP / Подбор ламината',
    elementText: 'Подобрать',
    elementVariant,
  });
};
